import { Box, styled, Button as Btn, css } from '@mui/material';

export const Container = styled(Box)`
  padding: 42px 30px 42px 30px;
  background: ${({ theme }) => theme.palette.grey[50]};
  width: 100%;
  height: 100%;
  overflow-y: overlay;
`;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  .css-1d3z3hw-MuiOutlinedInput-notchedOutline {
    border-style: 'hidden';
  }
`;

export const Button = styled(Btn)``;

export const Page = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Typography = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #000000;
`;

export const Text = styled(Box)``;

export const SectionCards = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  border-top: 1px solid #ffffff;
`;
export const Card = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 25px 20px;
  gap: 3px;
  width: 100%;

  :hover {
    background-color: #fbfbfb;
  }
`;
export const Date = styled(Typography)`
  margin: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
`;
export const Title = styled(Typography)`
  margin: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const Description = styled(Typography)`
  margin: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
`;
